export enum EnvOptions {
    LOCAL_TEST = "local-test",
    LOCAL = "local",
    DEV = "dev",
    STAGE = "stage",
    PROD = "prod"
}